import deductionsReducer from "./reducers";
export { default as deductionsTypes } from "./types";
export { default as deductionsActions } from "./actions";
export { default as deductionsOperations } from "./operations";
export default deductionsReducer;
